module.exports = __webpack_public_path__ + "static/img/img_i.5ac1a5ea.png";